import { useStore } from "@/stores/useStore";
import { useMemo } from "react";
import {
  DEFAULT_COMPLETED_ON_TIME_BUFFER_MIN,
  DEFAULT_CUSTOMER_UPDATE_SNOOZE_MIN,
} from "@/lib/const";
import { useFeature } from "@/hooks/useFeatures";

export const useCustomerUpdates = () => {
  const shop = useStore((state) => state.shop);
  const customerUpdatesFeatureEnabled = useFeature("isCustomerUpdatesEnabled");
  const customerUpdateInfo = useMemo(
    () => shop?.shopConfig?.customerUpdates,
    [shop]
  );

  const isCustomerUpdatesEnabled = useMemo(
    () =>
      customerUpdatesFeatureEnabled && (customerUpdateInfo?.enabled ?? false),
    [customerUpdateInfo]
  );

  const snoozeTimeMin = useMemo(
    () =>
      customerUpdateInfo?.defaultSnoozeBufferMin ??
      DEFAULT_CUSTOMER_UPDATE_SNOOZE_MIN,
    [customerUpdateInfo]
  );

  const customerUpdatesCompletedOnTimeMin = useMemo(
    () =>
      customerUpdateInfo?.defaultCompletedOnTimeBufferMin ??
      DEFAULT_COMPLETED_ON_TIME_BUFFER_MIN,
    [customerUpdateInfo]
  );

  return {
    isCustomerUpdatesEnabled,
    customerUpdateInfo,
    snoozeTimeMin,
    customerUpdatesCompletedOnTimeMin,
  };
};
